import { cn } from "@/lib/utils";
import { FilterCombobox } from "../../FilterCombobox";
import { Label } from "@/components/ui/label";
import { filterComboboxClassName } from "../TableStyles";
import {
  ConflictReason,
  ConflictReasonColors,
  ConflictReasonIcons,
  ConflictReasonLabels,
} from "../../../../models/ConflictReason";
import {
  MigrationFlagStatus,
  ConflictStatusColors,
  ConflictStatusLabels,
} from "../../../../models/Flags/MigrationFlagStatus";

interface FileConflictFilterProps {
  reason: string | null;
  status: string | null;
  onReasonChange: (newValue: string | null) => void;
  onStatusChange: (newValue: string | null) => void;
  className?: string;
}

/** Shared filter controls (reason + status comboboxes) for the SharePoint conflict resolution columns. */
export const FileConflictFilter = ({
  reason,
  status,
  onReasonChange,
  onStatusChange,
  className,
}: FileConflictFilterProps) => (
  <>
    <div className={cn(filterComboboxClassName, className)}>
      <Label className="text-xs font-semibold text-muted-foreground">Conflict reason</Label>
      <FilterCombobox
        value={reason}
        onChange={onReasonChange}
        placeholder="Conflict reason"
        options={Object.values(ConflictReason).map((r) => ({
          value: r,
          label: ConflictReasonLabels[r as ConflictReason],
          color: ConflictReasonColors[r as ConflictReason],
          icon: ConflictReasonIcons[r as ConflictReason],
        }))}
      />
    </div>
    <div className={cn(filterComboboxClassName, className)}>
      <Label className="text-xs font-semibold text-muted-foreground">Conflict status</Label>
      <FilterCombobox
        value={status}
        onChange={onStatusChange}
        placeholder="Conflict status"
        options={Object.values(MigrationFlagStatus).map((s) => ({
          value: s,
          label: ConflictStatusLabels[s as MigrationFlagStatus],
          color: ConflictStatusColors[s as MigrationFlagStatus],
        }))}
      />
    </div>
  </>
);
